'use client';

import Image from 'next/image';
import { useState } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron16.svg';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './Quote.styles';

const quoteText =
  'BIODERMA — наш давний и надежный партнер. Мы сотрудничаем уже шесть лет. Пройденный путь показал: бизнес действительно может быть искренним и чутким. Эта акция — пример системности в благотворительности, где каждый участник становится частью большого дела. Благодаря поддержке BIODERMA мы можем оказывать помощь нашим подопечным — от реабилитации и предоставления технических средств до поддержки горячей линии по ДЦП, а также, что крайне важно, планировать работу команды фонда.';

export function Quote({ className }: { className?: string }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const slots = styles({ isExpanded });

  return (
    <div className={slots.base({ className })}>
      <div className={slots.info()}>
        <Image
          className={slots.photo()}
          src={staticMediaUrl('landing/bioderma_galchonok/yureva.png')}
          alt="Анастасия Юрьева"
          width={148}
          height={148}
        />
        <div>
          <p className={slots.name()}>
            Анастасия
            <br className="lg:hidden" /> Юрьева
          </p>
          <p className={slots.position()}>
            Президент Благотворительного
            <br /> Фонда «ГАЛЧОНОК»
          </p>
        </div>
      </div>
      <div className={slots.quote()}>
        <Image
          className={slots.quoteStart()}
          src={staticMediaUrl('landing/bioderma_galchonok/guote-start.png')}
          alt="Цитата"
          width={38}
          height={38}
        />
        <p className={slots.text()}>{quoteText}</p>
        <button
          type="button"
          className={slots.readMore()}
          onClick={() => setIsExpanded((value) => !value)}
        >
          {isExpanded ? 'скрыть' : 'читать все'}
          <ChevronIcon
            className={slots.readMoreIcon()}
            aria-hidden
          />
        </button>
        <Image
          className={slots.quoteEnd()}
          src={staticMediaUrl('landing/bioderma_galchonok/guote-end.png')}
          alt="Цитата"
          width={38}
          height={38}
        />
      </div>
    </div>
  );
}
